import type { HomeStatus } from '../../../api/homeV3Api';

export const statusLabels: Record<HomeStatus, string> = {
    open: 'Open',
    inProgress: 'In progress',
    completed: 'Completed',
    cancelled: 'Cancelled',
    unknown: 'Unknown',
};

export function formatDate(value: string | null, includeTime = false) {
    if (!value) return 'Not available';
    const date = new Date(value);
    if (Number.isNaN(date.getTime())) return 'Not available';
    return new Intl.DateTimeFormat(undefined, includeTime
        ? { dateStyle: 'medium', timeStyle: 'short' }
        : { dateStyle: 'medium' }).format(date);
}

export function actionLabel(actionId: number | null) {
    return actionId == null ? 'Request' : `Request #${actionId}`;
}
